import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, Plus, Save, Truck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { GoogleCalendarCard } from "./GoogleCalendarCard";

const DAYS = ["Pon", "Wt", "Śr", "Czw", "Pt", "Sob", "Nd"];

export const SettingsTab = () => {
  const [s, setS] = useState(null);
  const [newSlot, setNewSlot] = useState("");
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)).catch((e) => toast.error(errMsg(e))); }, []);

  const save = async (next = s) => {
    try { const { data } = await api.put("/admin/settings", next); setS(data); toast.success("Zapisano ustawienia"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!s) return null;
  const toggleDay = (i) => setS({ ...s, working_days: s.working_days.includes(i) ? s.working_days.filter((d) => d !== i) : [...s.working_days, i] });
  const addSlot = () => { if (newSlot && !s.slots.includes(newSlot)) setS({ ...s, slots: [...s.slots, newSlot].sort() }); setNewSlot(""); };

  return (
    <div data-testid="admin-settings-tab" className="max-w-3xl space-y-6">
      <GoogleCalendarCard />
      <div className="panel p-6 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <Truck className="text-primary" size={28} strokeWidth={1.5} />
          <div><div className="font-semibold">Detailing mobilny</div><div className="text-xs text-muted-foreground">Gdy wyłączony, klienci nie mogą wybrać usługi mobilnej.</div></div>
        </div>
        <Switch data-testid="settings-mobile-switch" checked={s.mobile_enabled} onCheckedChange={(v) => save({ ...s, mobile_enabled: v })} />
      </div>
      <div className="panel p-6 space-y-6">
        <div>
          <h3 className="font-semibold mb-3">Dni pracy</h3>
          <div className="flex flex-wrap gap-2">
            {DAYS.map((d, i) => (
              <button key={d} data-testid={`settings-day-${i}`} onClick={() => toggleDay(i)}
                className={`px-4 py-2 rounded-md border text-sm transition-colors ${s.working_days.includes(i) ? "bg-primary text-black border-primary font-semibold" : "border-white/15 text-white/60"}`}>{d}</button>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-semibold mb-3">Godziny rozpoczęcia usług</h3>
          <div className="flex flex-wrap gap-2 mb-3">
            {s.slots.map((t) => (
              <span key={t} data-testid={`settings-slot-${t}`} className="inline-flex items-center gap-2 pl-3 pr-1 py-1 rounded-md border border-white/15 text-sm">
                {t}<button data-testid={`settings-slot-remove-${t}`} onClick={() => setS({ ...s, slots: s.slots.filter((x) => x !== t) })} className="p-1 hover:text-red-400"><X size={14} /></button>
              </span>
            ))}
          </div>
          <div className="flex gap-2 max-w-xs">
            <Input data-testid="settings-new-slot" type="time" value={newSlot} onChange={(e) => setNewSlot(e.target.value)} className="bg-black/40" />
            <button data-testid="settings-add-slot" onClick={addSlot} className="px-3 rounded-md border border-white/15 hover:border-primary"><Plus size={16} /></button>
          </div>
        </div>
        <label className="block max-w-xs text-sm">Rezerwacje z wyprzedzeniem maks. (dni)
          <Input data-testid="settings-days-ahead" type="number" min="1" value={s.days_ahead} onChange={(e) => setS({ ...s, days_ahead: Number(e.target.value) || 1 })} className="bg-black/40 mt-2" />
        </label>
        <button data-testid="settings-save-button" onClick={() => save()} className="btn-y px-6 py-2.5 text-sm inline-flex items-center gap-2"><Save size={16} /> Zapisz ustawienia</button>
      </div>
    </div>
  );
};
